module.exports={
	"Form": "ArtifactTypeEditManifest",
	"Scope": "ArtifactType-Edit",
	"Descriptors":
	{
		"ArtifactTypeDetails.IDArtifactType":
		{
			"Name": "ID",
			"Hash": "ArtifactTypeEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ArtifactTypeEditIdentity",
				"Group": "ArtifactTypeEditIdentity"
			}
		},
		"ArtifactTypeDetails.GUIDArtifactType":
		{
			"Name": "GUID",
			"Hash": "ArtifactTypeEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ArtifactTypeEditIdentity",
				"Group": "ArtifactTypeEditIdentity"
			}
		},
		"ArtifactTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ArtifactTypeEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ArtifactTypeEditIdentity",
				"Group": "ArtifactTypeEditIdentity"
			}
		},
		"ArtifactTypeDetails.Schemata":
		{
			"Name": "Schema Definition (JSON)",
			"Hash": "ArtifactTypeEdit-Schemata",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "ArtifactTypeEditSchema",
				"Group": "ArtifactTypeEditSchema"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ArtifactTypeEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ArtifactTypeEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Schema",
			"Hash": "ArtifactTypeEditSchema",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Schema",
					"Hash": "ArtifactTypeEditSchema",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
